import { ReactElement } from "react";
import { Button, Modal, ModalContent } from "@ps/ui-components";
import { classJoin } from "@ps/utils";
import { ReactComponent as RemoveImage } from "../../../../../../../images/remove-technology-group.svg";
import styles from "../../styles.module.css";
import { SKILLS_MATRIX_EXPERTISE_TEMPLATE } from "../../../../../../../shared/data-cy";
import { DeleteModalProps } from "../../types";
import { useTranslationWithNamespace } from "../../../../../../../hooks";

const DeleteGroupModal = ({
  onDelete,
  onCancel,
  isOpen,
  name,
}: DeleteModalProps): ReactElement => {
  const { t } = useTranslationWithNamespace();

  return (
    <Modal
      dataCy={`${SKILLS_MATRIX_EXPERTISE_TEMPLATE}_delete_group`}
      isOpen={isOpen}
      onClose={onCancel}
      height="h-auto"
      width="w-auto"
      withCloseIcon
    >
      <ModalContent
        additionalClassName={classJoin(
          styles.removeModalContent,
          "flex flex-row items-center justify-center py-8 px-40 gap-12",
        )}
      >
        <RemoveImage />
        <div className="flex flex-col gap-2 justify-center items-center pt-2">
          <span className="text-2xl font-semibold">
            {t("expertise.matrix.editMatrix.deleteGroup", { name })}
          </span>
          <span className="text-sm">
            {t("expertise.matrix.editMatrix.deleteGroupDescription", { name })}
          </span>
          <div className="flex gap-4 pt-2">
            <Button
              dataCy={`${SKILLS_MATRIX_EXPERTISE_TEMPLATE}_delete`}
              onClick={onDelete}
              type="submit"
            >
              {t("expertise.actions.delete")}
            </Button>
            <Button
              dataCy={`${SKILLS_MATRIX_EXPERTISE_TEMPLATE}_cancel`}
              variant="secondary"
              onClick={onCancel}
            >
              {t("expertise.actions.cancel")}
            </Button>
          </div>
        </div>
      </ModalContent>
    </Modal>
  );
};

export default DeleteGroupModal;
